/**
 * Header decoration/icon for a preference type category.
 *
 * Belongs here: header SVG or fund list UI.
 * Does not belong here: questionnaire flow.
 */
export function GoldPreferenceHeaderIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="130"
      height="160"
      viewBox="0 0 130 160"
      fill="none"
      className={className}
      aria-hidden
    >
      <g clipPath="url(#clip0_99328_278954)">
        <path d="M10.6591 107.278L1.90108 143.77C-0.0540011 151.916 6.12043 159.748 14.4979 159.748H64.6338C72.8087 159.748 78.94 152.269 77.3368 144.253L70.0384 107.761C68.8273 101.705 63.5106 97.3467 57.3354 97.3467H23.256C17.266 97.3467 12.0571 101.453 10.6591 107.278Z" fill="#F1E3B7" />
        <path d="M91.331 107.278L82.573 143.77C80.6179 151.916 86.7923 159.748 95.1698 159.748H145.306C153.481 159.748 159.612 152.269 158.009 144.253L150.71 107.761C149.499 101.705 144.182 97.3467 138.007 97.3467H103.928C97.9378 97.3467 92.7289 101.453 91.331 107.278Z" fill="#F1E3B7" />
        <path d="M50.9443 42.3795L42.1862 78.8715C40.2312 87.0176 46.4056 94.8493 54.7831 94.8493H104.919C113.094 94.8493 119.225 87.3703 117.622 79.3541L110.324 42.8622C109.112 36.8069 103.796 32.4482 97.6206 32.4482H63.5411C57.5511 32.4482 52.3422 36.5549 50.9443 42.3795Z" fill="#F1E3B7" />
        <path d="M19.1211 33.9404V58.9008" stroke="#F1E3B7" strokeWidth="12.9545" strokeLinecap="round" />
        <path d="M31.6309 46.3916L6.67044 46.3916" stroke="#F1E3B7" strokeWidth="12.9545" strokeLinecap="round" />
        <path d="M131.912 6.9873V31.9477" stroke="#F1E3B7" strokeWidth="12.9545" strokeLinecap="round" />
        <path d="M144.42 19.4385L119.46 19.4385" stroke="#F1E3B7" strokeWidth="12.9545" strokeLinecap="round" />
      </g>
      <defs>
        <clipPath id="clip0_99328_278954">
          <rect width="160" height="160" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
